export default __webpack_public_path__ + "static/media/carowie.15bbfa44.jpeg";